// const urlStatus = 'urlStatus'
export default {
	// 判断用户输入的url在查询中是什么状态，例如：链接不合法，链接为空，请求接口事等待的 loading 状态
	transStatus(state) {
    state.urlIsNull = false
    state.timeOut = false
    state.urlIsNo = false
    state.loading = false
	},
	transUrl(state, transUrl) {
    state.transUrl = transUrl
	},
	urlIsNull(state, urlIsNull) {
    state.urlIsNull = urlIsNull
  },
  urlIsNo(state, urlIsNo) {
    state.urlIsNo = urlIsNo
  },
  loading(state, loading) {
    state.loading = loading
  },
  timeOut(state, timeOut) {
    state.timeOut = timeOut
  },
  userInputUrl(state, userInputUrl) {
    state.userInputUrl = userInputUrl
  },
  searchUrl(state, searchUrl) {
    state.searchUrl = searchUrl
  }
}